import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Auto-refresh an expired access token on 401, then retry the original request once.
// Concurrent 401s share a single in-flight refresh call (request queue).
let refreshPromise = null;
const AUTH_SKIP = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    if (!response || response.status !== 401 || !config || config._retried) {
      return Promise.reject(error);
    }
    if (AUTH_SKIP.some((p) => (config.url || "").includes(p))) {
      return Promise.reject(error);
    }
    config._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(config);
    } catch (e) {
      return Promise.reject(error);
    }
  }
);

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function uploadDocument(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload-document", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function formatApiErrorDetail(detail, fallback = "Something went wrong. Please try again.") {
  if (detail && (detail.isAxiosError || detail.response)) detail = detail.response?.data?.detail ?? null;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
